var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallEndWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 9,
    viewBox: "0 0 20 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 2.50001C8.66675 2.50001 7.37509 2.70834 6.16675 3.10001V5.68334C6.16675 6.00834 5.97509 6.30001 5.70009 6.43334C4.88342 6.84168 4.14175 7.36668 3.48342 7.97501C3.33342 8.12501 3.12509 8.20834 2.90009 8.20834C2.66675 8.20834 2.45842 8.11668 2.30842 7.96668L0.241753 5.90001C0.163845 5.82438 0.10222 5.73362 0.0606614 5.63331C0.0191033 5.533 -0.00151044 5.42525 8.61357e-05 5.31668C8.61357e-05 5.08334 0.0917528 4.87501 0.241753 4.72501C2.78342 2.31668 6.21675 0.833344 10.0001 0.833344C13.7834 0.833344 17.2168 2.31668 19.7584 4.72501C19.9084 4.87501 20.0001 5.08334 20.0001 5.31668C20.0001 5.55001 19.9084 5.75834 19.7584 5.90834L17.6918 7.97501C17.5418 8.12501 17.3334 8.21668 17.1001 8.21668C16.8751 8.21668 16.6668 8.12501 16.5168 7.98334C15.8534 7.36471 15.104 6.84543 14.2918 6.44168C14.1513 6.37327 14.0329 6.26659 13.9504 6.13391C13.8678 6.00123 13.8244 5.84794 13.8251 5.69168V3.10834C12.6251 2.70834 11.3334 2.50001 10.0001 2.50001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallEndWhiteIcon);
export default __webpack_public_path__ + "static/media/call-end-white-icon.6e61af2a04bf7baf2549742bfcd19e3a.svg";
export { ForwardRef as ReactComponent };